import React from 'react'
import { Accordion as AccordionLeshenUI } from '@leshen/ui'
import { useMapi } from '../context/MapiProvider'

const Accordion = ({ items = [], spanish = false }) => {
  const { requestId } = useMapi()

  return (
    <AccordionLeshenUI items={items} spanish={spanish} requestId={requestId} />
  )
}

export default Accordion
